<template>
    <normal-lay-out>
        <div class="production-container">
            <page-header title="创建项目" @back="$router.go(-1)"></page-header>
            <div class="create-title">创建产品</div>
            <el-form :model="formData" label-width="100px" ref="topForm">
                <el-form-item label="产品名称" prop="name"
                              :rules="[{required: true, message: '请输入产品名称', trigger: 'change'}, {validator: formatProductName, trigger: 'change'}]">
                    <div :style="{width: '382px'}">
                        <el-input v-model="formData.name" maxlength="64" placeholder="请输入产品名称"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="协议类型" prop="protocolType" :rules="{required: true, message: '请选择协议类型', trigger: 'change'}">
                    <div class="protocol-selector" :style="{width: '480px'}">
                        <div class="protocol-item" :class="{'protocol-active': formData.protocolType === 0}" @click="formData.protocolType = 0" :style="{flex: 2}">MQTT</div>
                        <div class="protocol-item" :class="{'protocol-active': formData.protocolType === 1}" @click="formData.protocolType = 1" :style="{flex: 3}">LwM2M/CoAP</div>
                        <div class="protocol-item" :class="{'protocol-active': formData.protocolType === 2}" @click="formData.protocolType = 2" :style="{flex: 3}">HTTP/HTTP2</div>
                        <div class="protocol-item" :class="{'protocol-active': formData.protocolType === 3}" @click="formData.protocolType = 3" :style="{flex: 2}">Modbus</div>
                        <tip placement="top" :style="{marginLeft: '10px'}"
                             :text="['CoAP协议的设备需要完善数据解析，将设备上报的二进制数据转换为平台上的JSON数据格式', 'MQTT协议的设备，若采用二进制码流的数据格式，则需要完善数据解析，将设备上报的二进制数据转换为平台上的JSON数据格式。']"
                        />

                    </div>
                </el-form-item>
                <el-form-item label="数据格式" prop="dataEncode" :rules="{required: true, message: '请输入数据格式', trigger: 'change'}">
                    <el-select v-model="formData.dataEncode"  :style="{width: '382px'}">
                        <el-option key="JSON" :value="0" label="JSON" :disabled="formData.protocolType === 1"></el-option>
                        <el-option key="二进制码流" :value="1" label="二进制码流"></el-option>
                    </el-select>
                    <tip placement="right" :style="{marginLeft: '10px'}"
                         :text="['数据格式为二进制码流时，该产品下需要进行编解码插件开发。', '数据格式为JSON时，该产品下不需要进行编解码插件开发。']"
                    />
                </el-form-item>
                <el-form-item label="厂商名称" prop="companyName" :rules="[{required: true, message: '请输入厂商名称', trigger: 'change'}, {validator: formatCompanyName, trigger: 'change'}]">
                    <el-input v-model="formData.companyName" :style="{width: '382px'}" placeholder="请输入厂商名称" maxlength="32"></el-input>
                </el-form-item>
            </el-form>
            <div class="create-title" v-if="formData.name && formData.companyName">模型定义</div>
            <div class="tips" v-if="formData.name && formData.companyName">
                <p>
                    <span><i class="el-icon-warning" :style="{fontSize: 32, color: '#438BFF'}"></i></span>
                    在平台定义产品模型，使平台理解该产品的设备支持的属性、命令等信息。对于没有定义产品模型的设备，上报数据时平台仅直接转发，不做解析。</p>
            </div>
            <el-form :model="formData" label-width="100px" ref="bottomForm" :style="{marginTop: '10px'}" v-if="formData.name && formData.companyName">
                <el-form-item label="选择模型"
                              prop="modelType"
                              :rules="{validator: validModel, trigger: 'change'}">
                    <div :style="{width: '382px'}">
                        <el-radio-group  v-model="formData.modelType">
                            <el-radio :label="0">自定义模型</el-radio>
                            <el-radio :label="1">使用模型</el-radio>
                        </el-radio-group>
                    </div>
                    <div :style="{width: '800px'}" v-if="formData.modelType === 1">
                        <modal-selector v-model="selectedModel"></modal-selector>
                    </div>
                    <div :style="{width: '100%'}" v-else>
                        <el-button type="primary" size="small" @click="showAddServiceDialog" :style="{marginBottom: '12px'}">添加服务</el-button>
                        <service-item :item="item" :key="item.id"
                                      :clipboard="clipboard"
                                      @remove="removeServe(item)"
                                      v-for="item in modals" :is-edit-mode="true"></service-item>
                    </div>
                </el-form-item>
                <el-form-item label="所属行业" prop="industry">
                    <el-select v-model="formData.industry"  :style="{width: '382px'}">
                        <el-option :key="index" :value="item" :label="item"
                                   v-for="(item, index) in industry"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型" prop="deviceType" :rules="[{required: true, message: '请输入设备类型', trigger: 'change'}, {validator: formatDeviceType, trigger: 'change'}]">
                    <el-input v-model="formData.deviceType" :style="{width: '382px'}" placeholder="请输入设备类型" maxlength="32"></el-input>
                    <tip placement="top" :style="{marginLeft: '10px'}"
                         :text="['例如StreetLight（路灯）、GasMeter（气表）、WaterMeter（水表）等']"
                    />
                </el-form-item>
            </el-form>
            <div class="btn" :style="{marginBottom: '50px'}" v-if="formData.name && formData.companyName">
                <el-button type="primary" @click="create">立即创建</el-button>
            </div>
        </div>
        <add-service-dialog ref="addServiceDialog"/>
        <customInputDialog ref="customInputDialog"/>
    </normal-lay-out>
</template>

<script>
    import normalLayOut from "../../components/normalLayOut";
    import pageHeader from "../../components/pageHeader";
    import tip from "../../components/tip";
    import modalSelector from "./modalSelector";
    import serviceItem from "./serviceItem";
    import {mapActions} from 'vuex'
    import addServiceDialog from "./addServiceDialog";
    import Clipboard from 'clipboard';
    import {isCompanyName, isProductName} from "../../assets/js/utils";
    import customInputDialog from "./customInputDialog";
    import {dealErrorCode} from "../../store/server";

    export default {
        name: "production",
        components: {
            normalLayOut,
            pageHeader,
            tip,
            modalSelector,
            serviceItem,
            addServiceDialog,
            customInputDialog
        },
        data() {
            return {
                clipboard: null,
                formData: {
                    name: '',
                    protocolType: 0,
                    dataEncode: 0,
                    companyName: '',
                    modelType: 0,
                    industry: '无',
                    deviceType: '',
                },
                industry: ['无', '汽车制造业', '纺织业', '食品加工业', '金属制品业', '金属冶炼及压延加工业', '通用设备制造业', '专用设备制造业',
                    '橡胶和塑料制品业', '化学纤维制造业', '医疗制造业', '非金属矿物制造业', '交通运输设备制造业', '电气机械和器材制造业', '家具制造业',
                    '造纸及纸制品业', '文教体育用品制造业', '废弃资源和废旧材料回收加工业', '通信设备', '计算机及其他电子设备制造业', '仪器仪表及文化',
                    '办公用机械制造业', '工艺品及其他制造业', '木材加工及木、竹、藤、棕、草制品业', ],
                modals: [],
                selectedModel: null,
            }
        },
        watch: {
            'formData.protocolType'(v) {
                if (v === 1) {
                    this.formData.dataEncode = 1;
                } else {
                    this.formData.dataEncode = 0;
                }
            },
            selectedModel() {
                this.$refs.bottomForm.validateField('modelType');
            }
        },
        methods: {
            ...mapActions(['CreateProduct',  'SaveToModel']),
            back() {
                this.$route.pop()
            },
            removeServe(data) {
                let index = this.modals.indexOf(data);
                if (index === -1) {
                    return;
                }
                this.modals.splice(index, 1)
                this.$refs.bottomForm.validateField('modelType');
            },
            validModel(rule, value, callback) {
                if (value === 0 && this.modals.length === 0) {
                    callback(new Error('请添加服务'))
                    return;
                } else if (value === 1 && this.selectedModel === null) {
                    callback(new Error('请选择模型'))
                    return;
                }
                callback()
            },
            formatProductName(rule, value, callback) {
                if (!isProductName(value)) {
                    callback(new Error('产品名称只允许字母、数字、下划线、连字符的字符组合'))
                }
                callback()
            },
            formatDeviceType(rule, value, callback) {
                if (!isProductName(value)) {
                    callback(new Error('设备类型只允许字母、数字、下划线、连字符的字符组合'))
                }
                callback()
            },
            formatCompanyName(rule, value, callback) {
                if (!isCompanyName(value)) {
                    callback(new Error('厂商名称只允许中英文字符、数字、下划线、连字符的字符组合'))
                }
                callback()
            },
            async create() {
                await this.$refs.topForm.validate();
                await this.$refs.bottomForm.validate();
                let serves;
                if (this.formData.modelType === 0) {
                    serves = this.modals;
                } else if (this.formData.modelType === 1) {
                    serves = this.selectedModel.serves;
                }
                let res = await this.CreateProduct({...this.formData, serves});
                if (res.code === 1000 && !this.modals.length) {
                    this.$message.success('保存成功')
                    this.$router.go(-1)
                } else if (res.code === 1000 && this.modals.length) {
                    await this.saveModel(res.data);
                } else if (dealErrorCode(res.code)){
                    this.$message.error('保存失败')
                }
            },
            async showAddServiceDialog() {
                let res = await this.$refs.addServiceDialog.show({names: this.modals&&this.modals.map(item => item.id) || []});
                if (res === null) {
                    return
                }
                this.modals.push(res);
                this.$refs.bottomForm.validateField('modelType');
            },
            saveModel(productId) {
                this.$confirm('将新建的自定义模型保存到模型库，可供后期创建产品时快捷选择，是否需要保存？', '产品创建成功！', {
                    confirmButtonText: '保存',
                    cancelButtonText: '不保存',
                    showClose: false,
                }).then(async () => {
                    while(true) {
                        let name = await this.$refs.customInputDialog.show({title: '输入模型名称'})
                        if (name === null) {
                            return
                        }

                        let res = await this.SaveToModel({productId, modelName: name})
                        if (res.code === 1000) {
                            this.$message.success('保存成功')
                            this.$router.go(-1)
                            break;
                        } else if (res.code === 1008) {
                            this.$message.error('模型名称重复')
                        } else if (res.code === 1009) {
                            this.$message.error('对应产品不存在')
                        } else if (dealErrorCode(res.code)){
                            this.$message.error('保存失败')
                            break;
                        }
                    }
                }).catch(() => {
                    this.$router.go(-1)
                });

            }
        },
        mounted() {
            this.clipboard = new Clipboard('.copy-icon')
            this.clipboard.on('success', (e) => {
                this.$message.success('复制成功')
            });
        },
        beforeDestroy() {
            this.clipboard.destroy();
        }

    }
</script>

<style scoped>
    .production-container{
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background-color: white;
        overflow-x: hidden;
        padding: 0 40px;
        box-sizing: border-box;
        text-align: left;
    }

    .create-title{
        font-size: 18px;
        font-weight: 600;
        padding: 36px 0 24px;
    }

    .protocol-selector{
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .protocol-selector>.protocol-active {
        color: white;
        background-color: #3389FF;
    }

    .protocol-item{
        color: black;
        background-color: #E9F3FF;
        height: 100%;
        text-align: center;
        margin-right: 2px;
        cursor: pointer;
    }
    .btn{
        padding-left: 100px;
    }
</style>